export default {
    // 配件英语
    list: [
        {
            "id": "1712558913136",
            "parent_id": null,
            "name": "VERTEX",
            "sort": 0,
            "create_time": "2026-03-18T02:40:01.000Z",
            "children": [
                {
                    "id": "1773801706461",
                    "parent_id": "1712558913136",
                    "name": "Crushing Equipment",
                    "sort": 0,
                    "create_time": "2026-03-18T02:41:46.000Z",
                    "children": [
                        {
                            "id": "1773801759708",
                            "parent_id": "1773801706461",
                            "name": "Gyratory Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:42:40.000Z",
                            "children": [
                                {
                                    "id": "1773801977509",
                                    "parent_id": "1773801759708",
                                    "name": "VGT Series Gyratory Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:46:17.000Z",
                                    "children": [
                                        {
                                            "id": "1773801999492",
                                            "parent_id": "1773801977509",
                                            "name": "VGT4265",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:46:39.000Z"
                                        },
                                        {
                                            "id": "1773802011374",
                                            "parent_id": "1773801977509",
                                            "name": "VGT5065",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:46:51.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773801774076",
                            "parent_id": "1773801706461",
                            "name": "Jaw Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:42:54.000Z",
                            "children": [
                                {
                                    "id": "1773802038957",
                                    "parent_id": "1773801774076",
                                    "name": "VJ6X Series Jaw Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:47:19.000Z"
                                },
                                {
                                    "id": "1773802048004",
                                    "parent_id": "1773801774076",
                                    "name": "VJ5X Series Jaw Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:47:28.000Z",
                                    "children": [
                                        {
                                            "id": "1773812814923",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X80",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:46:55.000Z"
                                        },
                                        {
                                            "id": "1773812819090",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X100",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:46:59.000Z"
                                        },
                                        {
                                            "id": "1773812823150",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X110",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:03.000Z"
                                        },
                                        {
                                            "id": "1773812827605",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X125",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:08.000Z"
                                        },
                                        {
                                            "id": "1773812832677",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X145",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:13.000Z"
                                        },
                                        {
                                            "id": "1773812837390",
                                            "parent_id": "1773802048004",
                                            "name": "VJ5X160",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:17.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802055397",
                                    "parent_id": "1773801774076",
                                    "name": "VJW Series Jaw Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:47:35.000Z",
                                    "children": [
                                        {
                                            "id": "1773812783635",
                                            "parent_id": "1773802055397",
                                            "name": "VJW760",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:46:24.000Z"
                                        },
                                        {
                                            "id": "1773812789147",
                                            "parent_id": "1773802055397",
                                            "name": "VJW860",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:46:29.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802062399",
                                    "parent_id": "1773801774076",
                                    "name": "VJE Series Jaw Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:47:42.000Z",
                                    "children": [
                                        {
                                            "id": "1773812735099",
                                            "parent_id": "1773802062399",
                                            "name": "VJE600x900",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:45:35.000Z"
                                        },
                                        {
                                            "id": "1773812739935",
                                            "parent_id": "1773802062399",
                                            "name": "VJE750x1060",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:45:40.000Z"
                                        },
                                        {
                                            "id": "1773812745747",
                                            "parent_id": "1773802062399",
                                            "name": "VJE900x1200",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:45:46.000Z"
                                        },
                                        {
                                            "id": "1773812750510",
                                            "parent_id": "1773802062399",
                                            "name": "VJE1000x1200",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:45:50.000Z"
                                        },
                                        {
                                            "id": "1773812755484",
                                            "parent_id": "1773802062399",
                                            "name": "VJE1200x1500(003)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:45:55.000Z"
                                        },
                                        {
                                            "id": "1773812762018",
                                            "parent_id": "1773802062399",
                                            "name": "VJE1200x1500(001)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:46:02.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773801800154",
                            "parent_id": "1773801706461",
                            "name": "Impact Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:43:20.000Z",
                            "children": [
                                {
                                    "id": "1773802090834",
                                    "parent_id": "1773801800154",
                                    "name": "VI5X Series Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:48:11.000Z",
                                    "children": [
                                        {
                                            "id": "1773813233676",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1213",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:53:54.000Z"
                                        },
                                        {
                                            "id": "1773813238129",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1315(001)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:53:58.000Z"
                                        },
                                        {
                                            "id": "1773813242591",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1315(003)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:02.000Z"
                                        },
                                        {
                                            "id": "1773813246646",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1415(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:07.000Z"
                                        },
                                        {
                                            "id": "1773813251404",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1520",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:11.000Z"
                                        },
                                        {
                                            "id": "1773813256583",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1524",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:17.000Z"
                                        },
                                        {
                                            "id": "1773813261112",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1620(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:21.000Z"
                                        },
                                        {
                                            "id": "1773813267204",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X1630(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:27.000Z"
                                        },
                                        {
                                            "id": "1773813273245",
                                            "parent_id": "1773802090834",
                                            "name": "VI5X2030(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:54:33.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802099317",
                                    "parent_id": "1773801800154",
                                    "name": "VIW Series Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:48:19.000Z",
                                    "children": [
                                        {
                                            "id": "1773813153026",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1214-2（Discontinued）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:33.000Z"
                                        },
                                        {
                                            "id": "1773813157435",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1315-2（Discontinued）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:37.000Z"
                                        },
                                        {
                                            "id": "1773813162296",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1318-2（Discontinued）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:42.000Z"
                                        },
                                        {
                                            "id": "1773813167320",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1415-2（Discontinued）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:47.000Z"
                                        },
                                        {
                                            "id": "1773813171407",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1214-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:51.000Z"
                                        },
                                        {
                                            "id": "1773813176061",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1315-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:56.000Z"
                                        },
                                        {
                                            "id": "1773813180891",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1318-3（Discontinued）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:53:01.000Z"
                                        },
                                        {
                                            "id": "1773813189311",
                                            "parent_id": "1773802099317",
                                            "name": "VIW1415-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:53:09.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802111668",
                                    "parent_id": "1773801800154",
                                    "name": "VIF Series Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:48:32.000Z",
                                    "children": [
                                        {
                                            "id": "1773813107690",
                                            "parent_id": "1773802111668",
                                            "name": "VIF1010",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:51:48.000Z"
                                        },
                                        {
                                            "id": "1773813112842",
                                            "parent_id": "1773802111668",
                                            "name": "VIF1210",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:51:53.000Z"
                                        },
                                        {
                                            "id": "1773813118682",
                                            "parent_id": "1773802111668",
                                            "name": "VIF1214",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:51:59.000Z"
                                        },
                                        {
                                            "id": "1773813122891",
                                            "parent_id": "1773802111668",
                                            "name": "VIF1315",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:52:03.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773801812433",
                            "parent_id": "1773801706461",
                            "name": "Cone Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:43:32.000Z",
                            "children": [
                                {
                                    "id": "1773802148126",
                                    "parent_id": "1773801812433",
                                    "name": "VCP Series Multi-cylinder Hydraulic Cone Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:49:08.000Z",
                                    "children": [
                                        {
                                            "id": "1773813378201",
                                            "parent_id": "1773802148126",
                                            "name": "VCP300",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:56:18.000Z"
                                        },
                                        {
                                            "id": "1773813381915",
                                            "parent_id": "1773802148126",
                                            "name": "VCP500",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:56:22.000Z"
                                        },
                                        {
                                            "id": "1773813385964",
                                            "parent_id": "1773802148126",
                                            "name": "VCP800（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:56:26.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802157509",
                                    "parent_id": "1773801812433",
                                    "name": "VCC Series Single-cylinder Hydraulic Cone Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:49:18.000Z",
                                    "children": [
                                        {
                                            "id": "1773813308894",
                                            "parent_id": "1773802157509",
                                            "name": "VCC100H",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:09.000Z"
                                        },
                                        {
                                            "id": "1773813313192",
                                            "parent_id": "1773802157509",
                                            "name": "VCC100S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:13.000Z"
                                        },
                                        {
                                            "id": "1773813317502",
                                            "parent_id": "1773802157509",
                                            "name": "VCC160H",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:17.000Z"
                                        },
                                        {
                                            "id": "1773813321395",
                                            "parent_id": "1773802157509",
                                            "name": "VCC160S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:21.000Z"
                                        },
                                        {
                                            "id": "1773813325878",
                                            "parent_id": "1773802157509",
                                            "name": "VCC250H",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:26.000Z"
                                        },
                                        {
                                            "id": "1773813331562",
                                            "parent_id": "1773802157509",
                                            "name": "VCC250S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:31.000Z"
                                        },
                                        {
                                            "id": "1773813336555",
                                            "parent_id": "1773802157509",
                                            "name": "VCC315H",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:37.000Z"
                                        },
                                        {
                                            "id": "1773813341225",
                                            "parent_id": "1773802157509",
                                            "name": "VCC315S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:41.000Z"
                                        },
                                        {
                                            "id": "1773813345660",
                                            "parent_id": "1773802157509",
                                            "name": "VCC450S（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:46.000Z"
                                        },
                                        {
                                            "id": "1773813350992",
                                            "parent_id": "1773802157509",
                                            "name": "VCC600H（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:51.000Z"
                                        },
                                        {
                                            "id": "1773813356076",
                                            "parent_id": "1773802157509",
                                            "name": "VCC750H（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:55:56.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773801821774",
                            "parent_id": "1773801706461",
                            "name": "Vertical Shaft Impact Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:43:42.000Z",
                            "children": [
                                {
                                    "id": "1773802194827",
                                    "parent_id": "1773801821774",
                                    "name": "VS16X Series Vertical Shaft Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:49:55.000Z",
                                    "children": [
                                        {
                                            "id": "1773812945674",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC8015",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:06.000Z"
                                        },
                                        {
                                            "id": "1773812950536",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC9026",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:10.000Z"
                                        },
                                        {
                                            "id": "1773812955335",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1040",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:15.000Z"
                                        },
                                        {
                                            "id": "1773812960078",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1150",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:20.000Z"
                                        },
                                        {
                                            "id": "1773812968304",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1263",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:28.000Z"
                                        },
                                        {
                                            "id": "1773812974320",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1150G",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:34.000Z"
                                        },
                                        {
                                            "id": "1773812978594",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1263G",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:39.000Z"
                                        },
                                        {
                                            "id": "1773812982617",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1380G",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:43.000Z"
                                        },
                                        {
                                            "id": "1773812986927",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC13100G",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:47.000Z"
                                        },
                                        {
                                            "id": "1773812991361",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1040Z（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:51.000Z"
                                        },
                                        {
                                            "id": "1773812996196",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1150Z（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:49:56.000Z"
                                        },
                                        {
                                            "id": "1773813002724",
                                            "parent_id": "1773802194827",
                                            "name": "VSIC1263Z（Trial sale）",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:50:03.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802209032",
                                    "parent_id": "1773801821774",
                                    "name": "VSIB Series Vertical Shaft Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:50:09.000Z",
                                    "children": [
                                        {
                                            "id": "1773812908224",
                                            "parent_id": "1773802209032",
                                            "name": "VSIB7615",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:48:28.000Z"
                                        },
                                        {
                                            "id": "1773812912471",
                                            "parent_id": "1773802209032",
                                            "name": "VSIB8522",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:48:32.000Z"
                                        },
                                        {
                                            "id": "1773812916943",
                                            "parent_id": "1773802209032",
                                            "name": "VSIB9532",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:48:37.000Z"
                                        },
                                        {
                                            "id": "1773812921567",
                                            "parent_id": "1773802209032",
                                            "name": "VSIB1145",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:48:41.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802219118",
                                    "parent_id": "1773801821774",
                                    "name": "VSIA Series Vertical Shaft Impact Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:50:19.000Z",
                                    "children": [
                                        {
                                            "id": "1773812857537",
                                            "parent_id": "1773802219118",
                                            "name": "VSIA7611",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:38.000Z"
                                        },
                                        {
                                            "id": "1773812861862",
                                            "parent_id": "1773802219118",
                                            "name": "VSIA8518",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:42.000Z"
                                        },
                                        {
                                            "id": "1773812867126",
                                            "parent_id": "1773802219118",
                                            "name": "VSIA9526",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:47.000Z"
                                        },
                                        {
                                            "id": "1773812871488",
                                            "parent_id": "1773802219118",
                                            "name": "VSIA1140",
                                            "sort": 0,
                                            "create_time": "2026-03-18T05:47:51.000Z"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "1773801854300",
                    "parent_id": "1712558913136",
                    "name": "Feeding & Screening Equipment",
                    "sort": 0,
                    "create_time": "2026-03-18T02:44:14.000Z",
                    "children": [
                        {
                            "id": "1773801869576",
                            "parent_id": "1773801854300",
                            "name": "Feeder",
                            "sort": 0,
                            "create_time": "2026-03-18T02:44:30.000Z",
                            "children": [
                                {
                                    "id": "1773801893890",
                                    "parent_id": "1773801869576",
                                    "name": "VF5X Series Vibrating Feeder",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:44:54.000Z",
                                    "children": [
                                        {
                                            "id": "1773803506416",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1045",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:46.000Z"
                                        },
                                        {
                                            "id": "1773803512714",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1045M",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:53.000Z"
                                        },
                                        {
                                            "id": "1773803517503",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1345",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:57.000Z"
                                        },
                                        {
                                            "id": "1773803524211",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1345M",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:04.000Z"
                                        },
                                        {
                                            "id": "1773803530209",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1360",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:10.000Z"
                                        },
                                        {
                                            "id": "1773803535346",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1360S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:15.000Z"
                                        },
                                        {
                                            "id": "1773803540542",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1645",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:20.000Z"
                                        },
                                        {
                                            "id": "1773803546967",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1645M",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:27.000Z"
                                        },
                                        {
                                            "id": "1773803552374",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1660",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:32.000Z"
                                        },
                                        {
                                            "id": "1773803562353",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X1660S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:42.000Z"
                                        },
                                        {
                                            "id": "1773803566723",
                                            "parent_id": "1773801893890",
                                            "name": "VF5X2060",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:12:47.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773801910609",
                                    "parent_id": "1773801869576",
                                    "name": "VFG Series Vibrating Feeder",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:45:11.000Z",
                                    "children": [
                                        {
                                            "id": "1773803461308",
                                            "parent_id": "1773801910609",
                                            "name": "VFG0942",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:01.000Z"
                                        },
                                        {
                                            "id": "1773803467375",
                                            "parent_id": "1773801910609",
                                            "name": "VFG0942M",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:07.000Z"
                                        },
                                        {
                                            "id": "1773803471949",
                                            "parent_id": "1773801910609",
                                            "name": "VFG0942S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:12.000Z"
                                        },
                                        {
                                            "id": "1773803477634",
                                            "parent_id": "1773801910609",
                                            "name": "VFG1245",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:18.000Z"
                                        },
                                        {
                                            "id": "1773803481949",
                                            "parent_id": "1773801910609",
                                            "name": "VFG1245M",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:22.000Z"
                                        },
                                        {
                                            "id": "1773803486862",
                                            "parent_id": "1773801910609",
                                            "name": "VFG1245S",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:11:27.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773801919626",
                                    "parent_id": "1773801869576",
                                    "name": "VFP Series Vibrating Feeder",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:45:20.000Z",
                                    "children": [
                                        {
                                            "id": "1773803414870",
                                            "parent_id": "1773801919626",
                                            "name": "VFP0816",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:10:15.000Z"
                                        },
                                        {
                                            "id": "1773803419760",
                                            "parent_id": "1773801919626",
                                            "name": "VFP0816Z",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:10:20.000Z"
                                        },
                                        {
                                            "id": "1773803424330",
                                            "parent_id": "1773801919626",
                                            "name": "VFP1220",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:10:24.000Z"
                                        },
                                        {
                                            "id": "1773803429862",
                                            "parent_id": "1773801919626",
                                            "name": "VFP1220Z",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:10:30.000Z"
                                        },
                                        {
                                            "id": "1773803434941",
                                            "parent_id": "1773801919626",
                                            "name": "VFP1623Z",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:10:35.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773802262481",
                            "parent_id": "1773801854300",
                            "name": "Vibrating Screen",
                            "sort": 0,
                            "create_time": "2026-03-18T02:51:02.000Z",
                            "children": [
                                {
                                    "id": "1773802283369",
                                    "parent_id": "1773802262481",
                                    "name": "VS5X Series Vibrating Screen",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:51:23.000Z",
                                    "children": [
                                        {
                                            "id": "1773803141948",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1545-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:05:42.000Z"
                                        },
                                        {
                                            "id": "1773803146502",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1545-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:05:46.000Z"
                                        },
                                        {
                                            "id": "1773803151012",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1845-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:05:51.000Z"
                                        },
                                        {
                                            "id": "1773803155112",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1845-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:05:55.000Z"
                                        },
                                        {
                                            "id": "1773803160147",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1860-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:00.000Z"
                                        },
                                        {
                                            "id": "1773803165052",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1860-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:05.000Z"
                                        },
                                        {
                                            "id": "1773803169379",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X1860-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:09.000Z"
                                        },
                                        {
                                            "id": "1773803176346",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2160-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:16.000Z"
                                        },
                                        {
                                            "id": "1773803199726",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2160-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:40.000Z"
                                        },
                                        {
                                            "id": "1773803204406",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2160-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:44.000Z"
                                        },
                                        {
                                            "id": "1773803209026",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2460-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:49.000Z"
                                        },
                                        {
                                            "id": "1773803213868",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2460-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:54.000Z"
                                        },
                                        {
                                            "id": "1773803217895",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2460-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:06:58.000Z"
                                        },
                                        {
                                            "id": "1773803222326",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2760-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:07:02.000Z"
                                        },
                                        {
                                            "id": "1773803227831",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X2760-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:07:08.000Z"
                                        },
                                        {
                                            "id": "1773803236214",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3072-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:07:16.000Z"
                                        },
                                        {
                                            "id": "1773803241950",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3075-2T",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:07:22.000Z"
                                        },
                                        {
                                            "id": "1773803248471",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3075-3T",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:07:28.000Z"
                                        },
                                        {
                                            "id": "1773803307856",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3680-2T6",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:08:28.000Z"
                                        },
                                        {
                                            "id": "1773803316682",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3680-3T",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:08:37.000Z"
                                        },
                                        {
                                            "id": "1773803328697",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3685-2T(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:08:49.000Z"
                                        },
                                        {
                                            "id": "1773803338328",
                                            "parent_id": "1773802283369",
                                            "name": "VS5X3685-3T(Trial sale)",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:08:58.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802292445",
                                    "parent_id": "1773802262481",
                                    "name": "VSY Series Vibrating Screen",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:51:32.000Z",
                                    "children": [
                                        {
                                            "id": "1773802931886",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1237-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:12.000Z"
                                        },
                                        {
                                            "id": "1773802936044",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1237-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:16.000Z"
                                        },
                                        {
                                            "id": "1773802942284",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1237-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:22.000Z"
                                        },
                                        {
                                            "id": "1773802947878",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1548-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:28.000Z"
                                        },
                                        {
                                            "id": "1773802953962",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1548-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:34.000Z"
                                        },
                                        {
                                            "id": "1773802959081",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1548-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:39.000Z"
                                        },
                                        {
                                            "id": "1773802964365",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1848-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:44.000Z"
                                        },
                                        {
                                            "id": "1773802970066",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1848-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:50.000Z"
                                        },
                                        {
                                            "id": "1773802975318",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1848-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:02:55.000Z"
                                        },
                                        {
                                            "id": "1773802980104",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1860-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:03:00.000Z"
                                        },
                                        {
                                            "id": "1773802994939",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1860-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:03:15.000Z"
                                        },
                                        {
                                            "id": "1773802999691",
                                            "parent_id": "1773802292445",
                                            "name": "VSY1860-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:03:20.000Z"
                                        },
                                        {
                                            "id": "1773803027720",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2160-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:03:48.000Z"
                                        },
                                        {
                                            "id": "1773803035016",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2160-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:03:55.000Z"
                                        },
                                        {
                                            "id": "1773803041916",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2160-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:04:02.000Z"
                                        },
                                        {
                                            "id": "1773803047594",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2460-2",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:04:08.000Z"
                                        },
                                        {
                                            "id": "1773803055337",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2460-3",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:04:15.000Z"
                                        },
                                        {
                                            "id": "1773803062421",
                                            "parent_id": "1773802292445",
                                            "name": "VSY2460-4",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:04:22.000Z"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "1773802326100",
                    "parent_id": "1712558913136",
                    "name": "Purchased equipment, etc. (purchased and auxiliary equipment)",
                    "sort": 0,
                    "create_time": "2026-03-18T02:52:06.000Z",
                    "children": [
                        {
                            "id": "1773802365580",
                            "parent_id": "1773802326100",
                            "name": "Jaw Crusher (Third-party / Purchased)",
                            "sort": 0,
                            "create_time": "2026-03-18T02:52:45.000Z",
                            "children": [
                                {
                                    "id": "1773802378647",
                                    "parent_id": "1773802365580",
                                    "name": "Jaw Crusher (VJW/VJE Series)",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:52:59.000Z",
                                    "children": [
                                        {
                                            "id": "1773802410459",
                                            "parent_id": "1773802378647",
                                            "name": "VJW400x600",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:53:30.000Z"
                                        },
                                        {
                                            "id": "1773802437546",
                                            "parent_id": "1773802378647",
                                            "name": "VJW250x1000",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:53:57.000Z"
                                        },
                                        {
                                            "id": "1773802453131",
                                            "parent_id": "1773802378647",
                                            "name": "VJW250x1200",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:54:13.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773802478479",
                            "parent_id": "1773802326100",
                            "name": "Cone Crusher (Third-party / Purchased)",
                            "sort": 0,
                            "create_time": "2026-03-18T02:54:38.000Z",
                            "children": [
                                {
                                    "id": "1773802501681",
                                    "parent_id": "1773802478479",
                                    "name": "VCS Series Cone Crusher",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:55:02.000Z",
                                    "children": [
                                        {
                                            "id": "1773802634435",
                                            "parent_id": "1773802501681",
                                            "name": "VCS75",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:57:14.000Z"
                                        },
                                        {
                                            "id": "1773802641659",
                                            "parent_id": "1773802501681",
                                            "name": "VCS160",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:57:22.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802525877",
                                    "parent_id": "1773802478479",
                                    "name": "VCY Series Spare Parts (Great Wall)",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:55:26.000Z",
                                    "children": [
                                        {
                                            "id": "1773802664373",
                                            "parent_id": "1773802525877",
                                            "name": "VCY Series 600",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:57:44.000Z"
                                        },
                                        {
                                            "id": "1773802674895",
                                            "parent_id": "1773802525877",
                                            "name": "VCY Series 900",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:57:55.000Z"
                                        },
                                        {
                                            "id": "1773802681411",
                                            "parent_id": "1773802525877",
                                            "name": "VCY Series 1200",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:58:01.000Z"
                                        }
                                    ]
                                },
                                {
                                    "id": "1773802533198",
                                    "parent_id": "1773802478479",
                                    "name": "VCS Series Spare Parts(Great Wall)",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:55:33.000Z",
                                    "children": [
                                        {
                                            "id": "1773802693953",
                                            "parent_id": "1773802533198",
                                            "name": "VCS75",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:58:14.000Z"
                                        },
                                        {
                                            "id": "1773802699419",
                                            "parent_id": "1773802533198",
                                            "name": "VCS160",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:58:19.000Z"
                                        },
                                        {
                                            "id": "1773802706765",
                                            "parent_id": "1773802533198",
                                            "name": "VCS240",
                                            "sort": 0,
                                            "create_time": "2026-03-18T02:58:27.000Z"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "1773802552021",
                            "parent_id": "1773802326100",
                            "name": "Impact Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:55:52.000Z",
                            "children": [
                                {
                                    "id": "1773802574654",
                                    "parent_id": "1773802552021",
                                    "name": "VIF1010",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:56:15.000Z"
                                },
                                {
                                    "id": "1773802596236",
                                    "parent_id": "1773802552021",
                                    "name": "VIF1210",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:56:36.000Z"
                                },
                                {
                                    "id": "1773802602796",
                                    "parent_id": "1773802552021",
                                    "name": "VIF1214",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:56:43.000Z"
                                },
                                {
                                    "id": "1773802611526",
                                    "parent_id": "1773802552021",
                                    "name": "VIF1315",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:56:52.000Z"
                                }
                            ]
                        },
                        {
                            "id": "1773802735072",
                            "parent_id": "1773802326100",
                            "name": "Hammer Crusher",
                            "sort": 0,
                            "create_time": "2026-03-18T02:58:55.000Z",
                            "children": [
                                {
                                    "id": "1773802762524",
                                    "parent_id": "1773802735072",
                                    "name": "PC400x300",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:59:22.000Z"
                                },
                                {
                                    "id": "1773802771517",
                                    "parent_id": "1773802735072",
                                    "name": "PC600x400",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:59:31.000Z"
                                },
                                {
                                    "id": "1773802783876",
                                    "parent_id": "1773802735072",
                                    "name": "PC800x600",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:59:44.000Z"
                                },
                                {
                                    "id": "1773802793253",
                                    "parent_id": "1773802735072",
                                    "name": "PC1000x800",
                                    "sort": 0,
                                    "create_time": "2026-03-18T02:59:53.000Z"
                                },
                                {
                                    "id": "1773802802895",
                                    "parent_id": "1773802735072",
                                    "name": "PC1200x1000",
                                    "sort": 0,
                                    "create_time": "2026-03-18T03:00:03.000Z"
                                }
                            ]
                        },
                        {
                            "id": "1773803720522",
                            "parent_id": "1773802326100",
                            "name": "Sand Washer",
                            "sort": 0,
                            "create_time": "2026-03-18T03:15:21.000Z",
                            "children": [
                                {
                                    "id": "1773803741881",
                                    "parent_id": "1773803720522",
                                    "name": "LSX Series Spiral Sand Washer",
                                    "sort": 0,
                                    "create_time": "2026-03-18T03:15:42.000Z",
                                    "children": [
                                        {
                                            "id": "1773803773232",
                                            "parent_id": "1773803741881",
                                            "name": "LSX920",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:16:13.000Z"
                                        },
                                        {
                                            "id": "1773803778021",
                                            "parent_id": "1773803741881",
                                            "name": "2LSX920",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:16:18.000Z"
                                        },
                                        {
                                            "id": "1773803784278",
                                            "parent_id": "1773803741881",
                                            "name": "LSX1120",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:16:24.000Z"
                                        },
                                        {
                                            "id": "1773803788977",
                                            "parent_id": "1773803741881",
                                            "name": "2LSX1120",
                                            "sort": 0,
                                            "create_time": "2026-03-18T03:16:29.000Z"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}